module.exports = __webpack_public_path__ + "static/media/logo_azul.203b82f4.png";